var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_555_70685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7063 20.7062C14.3188 21.1 13.6812 21.1 13.2937 20.7062L9.29375 16.7062C8.9 16.3187 8.9 15.6812 9.29375 15.2937C9.68125 14.9 10.3188 14.9 10.7063 15.2937L14 18.5875L21.2938 11.2937C21.6813 10.9 22.3187 10.9 22.7062 11.2937C23.1 11.6812 23.1 12.3188 22.7062 12.7063L14.7063 20.7062ZM32 16C32 24.8375 24.8375 32 16 32C7.1625 32 0 24.8375 0 16C0 7.1625 7.1625 0 16 0C24.8375 0 32 7.1625 32 16ZM16 2C8.26875 2 2 8.26875 2 16C2 23.7313 8.26875 30 16 30C23.7313 30 30 23.7313 30 16C30 8.26875 23.7313 2 16 2Z",
    fill: "#15CB12"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99518 15.9935C9.99517 15.9935 9.99518 15.9935 9.99518 15.9935ZM9.29375 15.2937C8.9 15.6812 8.9 16.3187 9.29375 16.7062L13.2937 20.7062C13.6812 21.1 14.3188 21.1 14.7063 20.7062L22.7062 12.7063C23.1 12.3188 23.1 11.6812 22.7062 11.2937C22.3187 10.9 21.6813 10.9 21.2938 11.2937L14 18.5875L10.7063 15.2937C10.3188 14.9 9.68125 14.9 9.29375 15.2937ZM16.0019 31C24.2862 30.999 31 24.2846 31 16C31 7.71478 24.2852 1 16 1C24.2835 1 31 7.71646 31 16C31 24.2829 24.2846 30.999 16.0019 31ZM16 31C7.71542 31 1.00102 24.2862 1 16.0019C1.00103 24.2846 7.7171 31 16 31ZM1 16C1 7.7151 7.71522 1.00051 16 1C7.7169 1.00051 1 7.71678 1 16ZM16 32C24.8375 32 32 24.8375 32 16C32 7.1625 24.8375 0 16 0C7.1625 0 0 7.1625 0 16C0 24.8375 7.1625 32 16 32ZM2 16C2 8.26875 8.26875 2 16 2C23.7313 2 30 8.26875 30 16C30 23.7313 23.7313 30 16 30C8.26875 30 2 23.7313 2 16Z",
    fill: "#15CB12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_555_70685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOutline);
export default __webpack_public_path__ + "static/media/check-circle-outline.2baa129891c341d00961e268c52a73d6.svg";
export { ForwardRef as ReactComponent };